import json from '@/ts/json'

const apipath = process.env.NODE_ENV == 'development' ? 'http://localhost:9999/api' : '/api'

// single entry point: POST /api {name, req} -> {name, resp, error}
let send = async function(name, req){
  if (!req) req = {}
  console.log('req', name, req)
  const request = new Request(apipath, {
    headers: {"Content-Type": "application/json"},
    method: "POST",
    body: json.stringify({name, req}),
  });

  try {
    const response = await fetch(request)
    // ids are int64 on the API side: see ts/json.js
    let result = json.parse(await response.text()) || {}
    console.log('resp', name, result)
    return result || {}
  } catch (error) {
    console.error("Error:", error);
    return {error:{id:'try', code:500, error: error}}
  }
}

let file = async function(name, req, image){
  if (!req) req = {}
  const request = new Request(apipath, {
    headers: {"Content-Type": "application/json"},
    method: "POST",
    body: json.stringify({name, req}),
  });

  try {
    const response = await fetch(request)
    let result = await response.blob()
    if (image) return URL.createObjectURL(result)
    return result
  } catch (error) {
    console.error("Error:", error);
    return {error:{id:'try', code:500, error: error}}
  }
}

// raw body upload: POST /api/upload/... -> {resp:{file}} or {resp:{link}}
let upload = function(path, body){
  return new Promise(function (resolve, reject) {
    const rs = new XMLHttpRequest();
    rs.open('post', `${apipath}${path}`, true);
    rs.onload = function () {
      if (rs.status != 200) {
        reject({ error: { id: 'try', code: rs.status } });
        return
      }
      if (!rs.response) {
        resolve({});
        return
      }
      try {
        resolve(json.parse(rs.response) || {});
      } catch (error) {
        reject({ error: { id: 'parse', code: 500, error } });
      }
    };
    rs.onerror = function () { reject({ error: { id: 'try', code: 500 } }) };
    rs.send(new Uint8Array(body));
  });
}

// api
export default {

  async send(name, req) {return await send(name, req)},

  // support($route, $refs.supportMessage, console.logs)
  async support(route, message, logs) {return await send('support', {route, message, logs})},

  // team (api/admin_accounts.go)
  team:{
    async list() {return await send('admin/team/list', {})},
  },

  // assets (api/admin_assets.go)
  assets:{
    // q = model.AssetQuery {limit, offset, sort, desc, eq, gt, lt, not, like, in, ins}
    async search(q) {return await send('admin/assets/search', q || {})},
    // -> {asset, render, compact, account, files, score, history}
    async get(id) {return await send('admin/assets/get', {id})},
    async update(id, k, v) {return await send('admin/assets/update', {id, k, v})},
    async updateMeta(id, k, v) {return await send('admin/assets/update/meta', {id, k, v})},
    async delete(id) {return await send('admin/assets/delete', {id})},
    async verify(id) {return await send('admin/assets/verify', {id})},
    async priceAdd(id, usd, date) {return await send('admin/assets/price/add', {id, usd, date})},
    async priceDelete(id, date) {return await send('admin/assets/price/delete', {id, date})},
    async imageDelete(id, link) {return await send('admin/assets/image/delete', {id, link})},
  },

  // accounts (api/admin_accounts.go)
  accounts:{
    async get(id) {return await send('admin/accounts/get', {id})},
    async update(id, k, v) {return await send('admin/accounts/update', {id, k, v})},
    async search(q) {return await send('admin/accounts/search', q || {})},
    async delete(id) {return await send('admin/accounts/delete', {id})},
  },

  // dict: brands, models, submodels and custom lists (api/admin_dict_list.go)
  dict:{
    // {parent, name, limit, offset, like, fields}
    async search(q) {return await send('admin/dict/search', q || {})},
    // list = titles separated by new line or comma
    async create(parent, name, list) {return await send('admin/dict/create', {parent, name, list})},
    async update(id, k, v) {return await send('admin/dict/update', {id, k, v})},
    async updateMeta(id, k, v) {return await send('admin/dict/update/meta', {id, k, v})},
    async delete(id) {return await send('admin/dict/delete', {id})},
    async reset() {return await send('admin/dict/reset', {})},
  },

  // roots = asset categories (api/admin_dict_roots.go)
  roots:{
    async list() {return await send('dict/roots', {})},
    async create(list) {return await send('admin/roots/create', {list})},
    async update(id, k, v) {return await send('admin/roots/update', {id, k, v})},
    async updateMeta(id, k, v) {return await send('admin/roots/update/meta', {id, k, v})},
    async delete(id) {return await send('admin/roots/delete', {id})},
  },

  // gpt reindex for brands/models/submodels (api/admin_gpt.go)
  gpt:{
    async reindexBrands(root) {return await send('admin/gpt/reindex/brands', {root})},
    // root is required, brand or model narrows the list
    async quantity(root, brand, model) {return await send('admin/gpt/reindex/quantity', {root, brand, model})},
  },

  // market cap by brands (api/api_marketcap.go) -> [{id, title, qty, sum}]
  marketcap:{
    async category(root) {return await send('admin/gpt/marketcap/category', {root})},
    async brand(brand) {return await send('admin/gpt/marketcap/brand', {brand})},
    async model(model) {return await send('admin/gpt/marketcap/model', {model})},
  },

  download:{
     async image(id) {return await file('admin/files/download', {id}, true)},
     async file(id) {return await file('admin/files/download', {id})},
  },

  upload:{
    // brand/model logo, image = base64 -> {resp:{link}}
    async logo(id, image){return await send('admin/dict/upload/logo', {id, image})},

    // body = ArrayBuffer -> {resp:{file}}
    async image(body){return await upload('/upload/image', body)},

    // body = ArrayBuffer -> {resp:{file:{id, name, link...}}}
    async file(body, name, asset){
      let q = `?name=${encodeURIComponent(name || '')}`
      if (asset) q += `&asset=${asset}`
      return await upload(`/upload/file${q}`, body)
    },

    async doc(file){
      let body = await this.getbytes(file)
      return await upload(`/upload/doc?name=${encodeURIComponent(file.name)}`, body)
    },

    async getbytes(file) {
      return new Promise((resolve) => {
          var reader = new FileReader();
          reader.onload = e => {resolve(e.target.result)};
          reader.readAsArrayBuffer(file);
      });
    },
  },

}
